
import { useHydration } from 'quasar';
import { computed, defineComponent } from 'vue';

import { STATIC_DOCS } from 'SharedDir/backend/endpoints/docs';
import { usePersonalDataPolicyStore } from 'SharedDir/stores/personal-data-policy';

export default defineComponent({
  name: 'CookiesAcceptModal',
  setup() {
    const personalDataPolicyStore = usePersonalDataPolicyStore();
    const { isHydrated } = useHydration();
    const forceToAccept = computed(() => {
      return !personalDataPolicyStore.cookiesWasAccepted && isHydrated.value;
    });
    function acceptCookies() {
      personalDataPolicyStore.acceptCookies();
    }

    return {
      STATIC_DOCS,
      forceToAccept,
      acceptCookies,
    };
  },
});
